// Types
import { ReduxState } from '../../types/reduxTypes';

export const selectIsAppVisible = (state: ReduxState): boolean => state.getIn(['app', 'appVisibility']).isAppVisible;
